import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper active" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Loading2 = _resolveComponent("Loading2")!
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_Help = _resolveComponent("Help")!
  const _component_No2 = _resolveComponent("No2")!
  const _component_No3 = _resolveComponent("No3")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade2" }, {
      default: _withCtx(() => [
        (!_ctx.isLoadComplete)
          ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade2" }, {
      default: _withCtx(() => [
        (_ctx.isLoadComplete2)
          ? (_openBlock(), _createBlock(_component_Loading2, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view),
      _createVNode(_component_Footer)
    ]),
    _createVNode(_Transition, { name: "right" }, {
      default: _withCtx(() => [
        (_ctx.shouldShowHelpPopup)
          ? (_openBlock(), _createBlock(_component_Help, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.shouldShowTopPanel4)
          ? (_openBlock(), _createBlock(_component_No2, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.shouldShowTopPanel5)
          ? (_openBlock(), _createBlock(_component_No3, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}